module.exports = __webpack_public_path__ + "img/login.f8471c16.png";